import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RecaptchaComponent } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { AppSettings } from 'src/app/shared/App-Settings';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  @ViewChild('invisible', { static: false }) reCaptcha: RecaptchaComponent;

  CaptchSiteKey = AppSettings.RE_CAPTCHA_SITEKEY;
  forgorPasswordForm: FormGroup;
  isLoadingResults = false;
  isCaptchaExecuting = false;
  submitted = false;
  captchaResponse: string | null = null;
  private captchaResolver: ((token: string | null) => void) | null = null;

  timeLeft: number = 0;
  timerText: string = '';
  buttonEnabled: boolean = true;
  private interval: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.forgorPasswordForm = this.formBuilder.group({
      'email': [null, [Validators.required, Validators.email]],
      'SiteKey': [this.CaptchSiteKey]
    });
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.captchaTimeout) {
      clearTimeout(this.captchaTimeout);
    }
  }

  get fval() { return this.forgorPasswordForm.controls; }

  private captchaTimeout: any;

  private resolveCaptcha(token: string | null) {
    if (this.captchaTimeout) {
      clearTimeout(this.captchaTimeout);
      this.captchaTimeout = null;
    }
    if (this.captchaResolver) {
      this.captchaResolver(token);
      this.captchaResolver = null;
    }
  }

  reCaptchResolve(captchaResponse: string | null) {
    this.captchaResponse = captchaResponse;
    console.log("captchaResponse", captchaResponse);
    if (this.captchaResolver) {
      this.resolveCaptcha(captchaResponse);
    }
  }

  onErrorCaptcha() {
    // this.captchaResponse = null;
    if (this.captchaResolver) {
      this.resolveCaptcha(null);
    }
  }

  async executeCaptcha(): Promise<string | null> {
    // this.captchaResponse = null;

    if (!this.reCaptcha) {
      console.error('reCAPTCHA component is not initialized.');
      return null;
    }

    return new Promise((resolve) => {
      this.captchaResolver = resolve;

      try {
        // this.reCaptcha.reset();
        this.reCaptcha.execute();
      } catch (e) {
        console.error('Error executing captcha:', e);
        this.resolveCaptcha(null);
        return;
      }

      // Allow sufficient time for verification or interactive challenges (up to 2 minutes)
      this.captchaTimeout = setTimeout(() => {
        if (this.captchaResolver) {
          this.resolveCaptcha(null);
        }
      }, 120000);
    });
  }

  startTimer(duration: number = 60) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.timeLeft = duration;
    this.buttonEnabled = false;
    this.timerText = `in 00:${this.timeLeft < 10 ? '0' : ''}${this.timeLeft}s`;

    this.interval = setInterval(() => {
      if (this.timeLeft > 1) {
        this.timeLeft--;
        this.timerText = `in 00:${this.timeLeft < 10 ? '0' : ''}${this.timeLeft}s`;
      } else {
        this.buttonEnabled = true;
        this.timeLeft = 0;
        this.timerText = '';
        clearInterval(this.interval);
      }
    }, 1000);
  }

  async onFormSubmit() {
    this.submitted = true;
    if (this.forgorPasswordForm.invalid) {
      this.forgorPasswordForm.markAllAsTouched();
      return;
    }

    if (!this.buttonEnabled || this.isLoadingResults || this.isCaptchaExecuting) {
      return;
    }

    this.isCaptchaExecuting = true;
    const captchaToken = await this.executeCaptcha();
    this.isCaptchaExecuting = false;

    if (!captchaToken) {
      this.toastr.error('reCAPTCHA verification failed or is unavailable. Please try again.', 'Error');
      // if (this.reCaptcha) {
      //   this.reCaptcha.reset();
      // }
      return;
    }

    this.isLoadingResults = true;
    this.authenticationService.forgotPassword(this.fval.email.value).subscribe({
      next: (data: any) => {
        this.isLoadingResults = false;
        this.toastr.success(data.message || data || 'Password reset link has been sent on your registered email.');
        this.forgorPasswordForm.reset({
          email: null,
          SiteKey: this.CaptchSiteKey
        });
        // this.captchaResponse = null;
        // if (this.reCaptcha) {
        //   this.reCaptcha.reset();
        // }
        this.submitted = false;
        this.startTimer(60);
      },
      error: (err) => {
        this.isLoadingResults = false;
        this.captchaResponse = null;
        // if (this.reCaptcha) {
        //   this.reCaptcha.reset();
        // }
        this.toastr.error(err, 'Error');
        console.log(err);
      }
    });
  }
}
